import { AxiosResponseHeaders } from 'axios';
import { DocumentsResponseDTO, Document } from '../entities';

const documentsResponseDTOToDocumentsAdapter = (data: DocumentsResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body.documents.map(doc => new Document(doc.fileId, doc.fileName, doc.fileDescription, doc.fileData));
};

export { documentsResponseDTOToDocumentsAdapter };
